import React from "react";
import Header from "../Components/Header/Header";
import BinStatus from "../Components/BinStatus/BinStatus";
import BinTable from "../Components/Tables/BinTable";
import GoBackButton from "../Components/Buttons/GoBackButton";
import DetailsPageHead from "../Components/PageHead/DetailsPageHead";
import BinDetailComp from "../Components/DetailsPageComp/BinDetailComp";


const BinDetails = ()=> {
    return(
        <>
            <Header />
            <div className="max-w-screen-xl px-4 mx-auto">
                <GoBackButton />
                <div className="">
                    <DetailsPageHead pageDetHeading={'Bin#1233'} />
                </div>  
                <div className="mt-9">
                    <BinDetailComp heading={'Resident Name:'} detail={'Lorem ipsum'}/>
                    <BinDetailComp heading={'Location:'} detail={'Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur error labore sint vel molestias iste fugiat culpa, quae ullam nulla, blanditiis soluta ducimus repellendus, qui eum minima possimus illo delectus.'}/>
                    <BinDetailComp heading={'Status:'} detail={'filled'}/>
                    <BinDetailComp heading={'Last Updated:'} detail={'12-03-2023 9:00AM'}/>
                    
                </div>
            </div>
        </>
    )
}

export default BinDetails